document.addEventListener('DOMContentLoaded', function() { // S'assurer que le script est exécuté après le chargement du DOM
    var emailInput = document.getElementById('email');
    var notifyButton = document.getElementById('notify-button');
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var backInStockElement = document.getElementById('back-in-stock');
    var variantId = backInStockElement.getAttribute('data-variant-id');
    var backInStockForm = document.getElementById('back-in-stock-form');
    var location = backInStockForm.getAttribute('data-location');


    // Ouvrir le modal au clic sur le bouton
    document.querySelector('.klaviyo-bis-trigger').addEventListener('click', function(event) {
      event.preventDefault();
      document.getElementById('klaviyo-bis-modal').style.display = 'block';
    });

    // Fermer le modal au clic sur le bouton "Close"
    document.querySelector('.klaviyo-bis-close').addEventListener('click', function(event) {
    event.preventDefault();
    document.getElementById('klaviyo-bis-modal').style.display = 'none';
    document.getElementById('completed_message').style.display = 'none';
    document.getElementById('email').value = '';
    document.getElementById('error_message').style.display = 'none';
    notifyButton.style.display = 'block';  
    });
  

    // Activer ou désactiver le bouton en fonction de la validité de l'email
    emailInput.addEventListener('input', function() {
      if (regex.test(emailInput.value)) {
        notifyButton.disabled = false;  // Activer le bouton si l'email est valide
        document.getElementById('error_message').style.display = 'none';  // Masquer le message d'erreur
      } else {
        notifyButton.disabled = true;  // Désactiver le bouton si l'email est invalide
      }
    });
    
    emailInput.addEventListener('blur', function() {
      if (!regex.test(emailInput.value)) {
        document.getElementById('error_message').style.display = 'block';  // Afficher le message d'erreur seulement lorsque l'utilisateur quitte le champ
      }
    });
    
      const form = document.getElementById('back-in-stock-form');

    
    form.addEventListener('submit', function(event) {
      var email = emailInput.value;
      event.preventDefault();  // Empêche la soumission classique du formulaire
      

      // Vérifier que l'email est valide avant soumission
      if (regex.test(email) === false) {
        document.getElementById('error_message').style.display = 'block';
        return;
      }

      // Fonction pour soumettre à Klaviyo
      myfunction(email, variantId, location);
    });

    function myfunction(email, variantId, location) {
      const id = `$custom:::$default:::${variantId}-${location}`;
      console.log(id);
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-07-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        profile: {data: {type: 'profile', attributes: {email: email}}},
        channels: ['EMAIL']
      },
      relationships: {
        variant: {
          data: {type: 'catalog-variant', id: id}
        }
      }
    }
  })
};

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VUqJJw', options)
        .then(response => {
            if (response.ok) {
                document.getElementById('completed_message').style.display = 'block';
                notifyButton.style.display = 'none';  
                  return response.text();  
            } else {
                  return response.text().then(text => {
                  return text ? JSON.parse(text) : {}; 
                  });
            }
        })
      .then(data => console.log('Success:', data))  // Log the data returned from the API
      .catch(err => console.error('Error:', err));  // Log errors if they occur
    }
    
  });